import { Component, OnInit, ViewChild, ElementRef }  from '@angular/core';
import { Router, ROUTER_DIRECTIVES } from '@angular/router';
import { IScenario, ScenarioService, ScenarioForecastRequest, ScenarioForecastResponse } from './scenario.service';
import { CommonDataService, SystemControl } from '../common-data/commondata.service';
import { UserSession } from '../shared/user-session';
import {Messages} from 'primeng/primeng';
import { Dialog } from 'primeng/primeng';
import { AirportOperations } from './airport-operations';
import { BasedAircraft } from './based-aircraft';
import { Enplanements } from './enplanements';
import { TraconOperations } from '../system-management/tracon-models/tracon-operations';

@Component({
    template: require('./scenario-reforecast.component.html'),
    styles: [require('../styles/faa_styles.css')],
    providers: [ScenarioForecastRequest, AirportOperations, BasedAircraft, Enplanements, TraconOperations],
    directives: [ROUTER_DIRECTIVES],
})

export class ScenarioReforecastComponent implements OnInit {
    pageTitle: string = 'Reforecast Using Stored Rates';
    errorMessage: string;
    currentScenario: IScenario;
    allScenarios: IScenario[];
    startYears: number[] = [];
    endYears: number[] = [];
    aopsEnabled: boolean = false;
    basedAircraftEnabled: boolean = false;
    enplanementsEnabled: boolean = false;
    traconsEnabled: boolean = false;
    aopsCssClass: string = 'glyphicon glyphicon-chevron-right';
    basedAircraftCssClass: string = 'glyphicon glyphicon-chevron-right';
    enplanementsCssClass: string = 'glyphicon glyphicon-chevron-right';
    traconsCssClass: string = 'glyphicon glyphicon-chevron-right';
    aopsMenuCssClass: string = 'menu-items';
    baMenuCssClass: string = 'menu-items';
    enplMenuCssClass: string = 'menu-items';
    traconMenuCssClass: string = 'menu-items';
    reforecastButtonCssClass: string = 'btn btn-primary';
    reforecastButtonSpinnerCssClass: string = 'hidden';
    reforecastButtonText: string = 'Reforecast';
    processingCssClass: string = 'processing';
    displaySpinner :boolean=false;
    msgs: Messages[]=[];
    bProcess:boolean=false;
    scenarioHeaderDiv: HTMLDivElement;

    constructor(private _router: Router,
        private _commonDataService: CommonDataService,
        private _scenarioService: ScenarioService,
        private _user: UserSession,
        private _request: ScenarioForecastRequest) { }

    @ViewChild('scenarioHeader') scenarioHeader: ElementRef;

    ngOnInit() {
        this.displaySpinner = false;
        if (typeof (this._user.scenarioId) === 'undefined')
            this._router.navigate(['./scenario-activities']);

        this.scenarioHeaderDiv = this.scenarioHeader.nativeElement;
        this._scenarioService.getScenarios(this._user.getSession()['id'])
            .subscribe(
                scenarios => this.allScenarios = scenarios,
                error => this.errorMessage = <any>error,
                () => {
                    this.setScenarioHeader(this._user.getSession().scenarioId);
                }
            );

        // Retrieve SystemControl so we can populate years for the date ranges
        this._commonDataService.getSystemControlData()
            .subscribe(
            (record: SystemControl) => {
                let minYear: number = record.fyYear - 3;
                let maxYear: number = record.lfcYear;

                for (let x: number = minYear; x <= maxYear; x++) {
                    this.startYears.push(x);
                }
                for (let x: number = maxYear; x >= minYear; x--) {
                    this.endYears.push(x);
                }
                this._request.startYear = this.startYears[0];
                this._request.endYear = this.endYears[0];
            },
            error => this.errorMessage = <any>error
            );
    }
    onScenarioChange(event: Event): void {
        let selectedScenarioId: number = +(event.target as HTMLSelectElement).value;
        this._user.scenarioId = selectedScenarioId;
        this.setScenarioHeader(selectedScenarioId);
        this._user.updateSessionState();
    }
    private setScenarioHeader(scenarioId: number):void {
        let foundScenarios:IScenario[] = this.allScenarios.filter(function(scenario){
            return scenario.id === scenarioId;
        });
        if(foundScenarios.length > 0){
            this.currentScenario = foundScenarios[0];
        }
        this.scenarioHeaderDiv.innerHTML = `<strong>Current Scenario: ${this.currentScenario.scenarioName} (${this.currentScenario.id})</strong>`;
    }
    menuClick(event: Event, menu: string): void {
        switch (menu) {
            case 'aops':
                if (!this.aopsEnabled) {
                    this.aopsEnabled = true;
                    this.aopsCssClass = this.aopsCssClass.replace('right', 'down');
                    this.aopsMenuCssClass = this.aopsMenuCssClass.concat('-visible');
                    this._request.airportOperations = new AirportOperations();
                    this._request.airportOperations.ifrItnAt = false;
                    this._request.airportOperations.ifrItnAc = false;
                    this._request.airportOperations.ifrItnGa = false;
                    this._request.airportOperations.ifrItnMi = false;
                    this._request.airportOperations.itnAirCarrier = false;
                    this._request.airportOperations.itnAirTaxi = false;
                    this._request.airportOperations.itnGa = false;
                    this._request.airportOperations.itnMil = false;
                    this._request.airportOperations.localGa = false;
                    this._request.airportOperations.localMil = false;
                    this._request.airportOperations.totalOverflights = false;
                } else {
                    this.aopsEnabled = false;
                    this.aopsCssClass = this.aopsCssClass.replace('down', 'right');
                    this.aopsMenuCssClass = this.aopsMenuCssClass.replace('-visible', '');
                    this._request.airportOperations = undefined;
                }
                break;
            case 'ba':
                if (!this.basedAircraftEnabled) {
                    this.basedAircraftEnabled = true;
                    this.basedAircraftCssClass = this.basedAircraftCssClass.replace('right', 'down');
                    this.baMenuCssClass = this.baMenuCssClass.concat('-visible');
                    this._request.basedAircraft = new BasedAircraft();
                    this._request.basedAircraft.helicopter = false;
                    this._request.basedAircraft.jet = false;
                    this._request.basedAircraft.multi = false;
                    this._request.basedAircraft.other = false;
                    this._request.basedAircraft.single = false;
                } else {
                    this.basedAircraftEnabled = false;
                    this.basedAircraftCssClass = this.basedAircraftCssClass.replace('down', 'right');
                    this.baMenuCssClass = this.baMenuCssClass.replace('-visible', '');
                    this._request.basedAircraft = undefined;
                }
                break;
            case 'enpl':
                if (!this.enplanementsEnabled) {
                    this.enplanementsEnabled = true;
                    this.enplanementsCssClass = this.enplanementsCssClass.replace('right', 'down');
                    this.enplMenuCssClass = this.enplMenuCssClass.concat('-visible');
                    this._request.enplanements = new Enplanements();
                    this._request.enplanements.airCarrier = false;
                    this._request.enplanements.airTaxi = false;
                    this._request.enplanements.commuter = false;
                    this._request.enplanements.foreignFlag = false;
                    this._request.enplanements.usFlag = false;
                } else {
                    this.enplanementsEnabled = false;
                    this.enplanementsCssClass = this.enplanementsCssClass.replace('down', 'right');
                    this.enplMenuCssClass = this.enplMenuCssClass.replace('-visible', '');
                    this._request.enplanements = undefined;
                }
                break;
            case 'tracon':
                if (!this.traconsEnabled) {
                    this.traconsEnabled = true;
                    this.traconsCssClass = this.traconsCssClass.replace('right', 'down');
                    this.traconMenuCssClass = this.traconMenuCssClass.concat('-visible');
                    this._request.traconOperations = new TraconOperations();
                    this._request.traconOperations.airCarrier = false;
                    this._request.traconOperations.airTaxi = false;
                    this._request.traconOperations.generalAviation = false;
                    this._request.traconOperations.military = false;
                    this._request.traconOperations.totalOverflights = false;
                } else {
                    //alert(" traconenable=false");
                    this.traconsEnabled = false;
                    this.traconsCssClass = this.traconsCssClass.replace('down', 'right');
                    this.traconMenuCssClass = this.traconMenuCssClass.replace('-visible', '');
                    this._request.traconOperations = undefined;
                }
                break;
        }
    }

    onSelectChange(event: Event, source: string) {
        let select: HTMLSelectElement = event.target as HTMLSelectElement;
        switch (source) {
            case 'scenario':
                this._request.scenarioId = +select.value;
                let scenarioId = this._request.scenarioId;
                let match: IScenario = this.allScenarios.filter(function (s: IScenario) {
                    return s.id === scenarioId;
                })[0];

                this._request.setNameInSession(match.scenarioName);
                break;
            case 'startYears':
                this._request.startYear = +select.value;
                break;
            case 'endYears':
                this._request.endYear = +select.value;
                break;
        }
    }

    onCheckboxChange(event: Event, section: string, option: string): void {
        let checkbox: HTMLInputElement = event.target as HTMLInputElement;
        switch (section) {
            case 'aops':
                switch (option) {
                    case 'itnAirCarrier':
                        this._request.airportOperations.itnAirCarrier = checkbox.checked;
                        break;
                    case 'itnAirTaxi':
                        this._request.airportOperations.itnAirTaxi = checkbox.checked;
                        break;
                    case 'itnGa':
                        this._request.airportOperations.itnGa = checkbox.checked;
                        break;
                    case 'itnMil':
                        this._request.airportOperations.itnMil = checkbox.checked;
                        break;
                    case 'localGa':
                        this._request.airportOperations.localGa = checkbox.checked;
                        break;
                    case 'localMil':
                        this._request.airportOperations.localMil = checkbox.checked;
                        break;
                    case 'totalOverflights':
                        this._request.airportOperations.totalOverflights = checkbox.checked;
                        break;
                    case 'ifrItnAc':
                        this._request.airportOperations.ifrItnAc = checkbox.checked;
                        break;
                    case 'ifrItnAt':
                        this._request.airportOperations.ifrItnAt = checkbox.checked;
                        break;
                    case 'ifrItnGa':
                        this._request.airportOperations.ifrItnGa = checkbox.checked;
                        break;
                    case 'ifrItnMi':
                        this._request.airportOperations.ifrItnMi = checkbox.checked;
                        break;
                }
                break;
            case 'ba':
                switch (option) {
                    case 'single':
                        this._request.basedAircraft.single = checkbox.checked;
                        break;
                    case 'jet':
                        this._request.basedAircraft.jet = checkbox.checked;
                        break;
                    case 'multi':
                        this._request.basedAircraft.multi = checkbox.checked;
                        break;
                    case 'helicopter':
                        this._request.basedAircraft.helicopter = checkbox.checked;
                        break;
                    case 'other':
                        this._request.basedAircraft.other = checkbox.checked;
                        break;
                }
                break;
            case 'enpl':
                switch (option) {
                    case 'airCarrier':
                        this._request.enplanements.airCarrier = checkbox.checked;
                        break;
                    case 'airTaxi':
                        this._request.enplanements.airTaxi = checkbox.checked;
                        break;
                    case 'commuter':
                        this._request.enplanements.commuter = checkbox.checked;
                        break;
                    case 'usFlag':
                        this._request.enplanements.usFlag = checkbox.checked;
                        break;
                    case 'foreignFlag':
                        this._request.enplanements.foreignFlag = checkbox.checked;
                        break;
                }
                break;
            case 'tracon':
                switch (option) {
                    case 'airCarrier':
                        this._request.traconOperations.airCarrier = checkbox.checked;
                        break;
                    case 'airTaxi':
                        this._request.traconOperations.airTaxi = checkbox.checked;
                        break;
                    case 'generalAviation':
                        this._request.traconOperations.generalAviation = checkbox.checked;
                        break;
                    case 'military':
                        this._request.traconOperations.military = checkbox.checked;
                        break;
                    case 'totalOverflights':
                        this._request.traconOperations.totalOverflights = checkbox.checked;
                        break;
                }
                break;
        }
    }

    reforecast(): void {

        if (this._request.startYear >= this._request.endYear) {
            this.msgs=[];
            this.msgs.push({severity:'error', summary:'Error Message', detail: 'Start year must be less than End year'});
            this.bProcess = true;
        }

        // Check if all datasets is set to null
        if ((typeof(this._request.airportOperations) === 'undefined') &&
            typeof(this._request.basedAircraft) === 'undefined' &&
            typeof(this._request.enplanements) === 'undefined' &&
            typeof(this._request.traconOperations) === 'undefined') {            
            this.msgs.push({severity:'error', summary:'Error Message', detail: 'Please select a dataset'});
            this.bProcess = true;
        }
        
     
        // Check Airport Operations dataset options
        if (typeof(this._request.airportOperations) != 'undefined' &&
            (this._request.airportOperations.ifrItnAc ===false) &&
            (this._request.airportOperations.ifrItnAt ===false) &&
            (this._request.airportOperations.ifrItnGa ===false) &&
            (this._request.airportOperations.ifrItnMi ===false) &&
            (this._request.airportOperations.itnAirCarrier ===false) &&
            (this._request.airportOperations.itnAirTaxi ===false) &&
            (this._request.airportOperations.itnGa ===false) &&
            (this._request.airportOperations.itnMil ===false) &&
            (this._request.airportOperations.localGa  ===false) &&
            (this._request.airportOperations.localMil ===false) &&
            (this._request.airportOperations.totalOverflights ===false)) {
            this.msgs.push({severity:'error', summary:'Error Message', detail: 'Please select a dataset option from Airport Operations'});
           this.bProcess = true;
        }
        // Check Based Aircraft dataset options
        if (typeof(this._request.basedAircraft) != 'undefined' &&
            (this._request.basedAircraft.helicopter ===false) &&
            (this._request.basedAircraft.jet ===false) &&
            (this._request.basedAircraft.multi === false) &&
            (this._request.basedAircraft.other === false) &&
            (this._request.basedAircraft.single === false)) {
            this.msgs.push({severity:'error', summary:'Error Message', detail: 'Please select a dataset option from Based Aircraft'});
            this.bProcess = true;
        }

        // Check Enplanements dataset options
        if (typeof(this._request.enplanements) != 'undefined' &&
            (this._request.enplanements.airCarrier === false) &&
            (this._request.enplanements.airTaxi ===false) &&
            (this._request.enplanements.commuter === false) &&
            (this._request.enplanements.foreignFlag ===false) &&
            (this._request.enplanements.usFlag ===false)) {
            this.msgs.push({severity:'error', summary:'Error Message', detail: 'Please select a dataset option from Enplanements'});
            this.bProcess = true;
        }

        // Check Tracon Operations dataset options
        if (typeof(this._request.traconOperations) != 'undefined' &&
            (this._request.traconOperations.airCarrier === false) &&
            (this._request.traconOperations.airTaxi === false) &&
            (this._request.traconOperations.generalAviation === false) &&
            (this._request.traconOperations.military === false) &&
            (this._request.traconOperations.totalOverflights === false)) {
            this.msgs.push({severity:'error', summary:'Error Message', detail: 'Please select a dataset option from Tracon Operations'});
            this.bProcess = true;
        }
        if(!this.bProcess ){
            this.msgs=[];
            this.displaySpinner = true;
            this.processingCssClass = this.processingCssClass.concat('-visible');
            this.reforecastButtonCssClass = this.reforecastButtonCssClass.replace('btn-primary','btn-processing');
            this.reforecastButtonText = '   Processing...';

            this._scenarioService.executeReforecast(this._request)
                .subscribe(
                (response: ScenarioForecastResponse) => {
                    this.displaySpinner = false;
                    if (response.responseStatus === 'ERROR') {
                        this.processingCssClass = this.processingCssClass.replace('-visible', '');
                        this.reforecastButtonCssClass = this.reforecastButtonCssClass.replace('btn-processing','btn-primary');
                        this.reforecastButtonSpinnerCssClass = 'hidden';
                        this.reforecastButtonText = 'Reforecast';
                        this.msgs=[];
                        this.msgs.push({severity:'error', summary:'Error Message', detail: 'An error has occurred executing your request'});
                        return;
                    }
                    this._router.navigate(['./scenario-reforecast-complete']);
                },
                error => this.errorMessage = <any>error
                );
        }
        else{
            this.bProcess =false;
        }
    }

    cancel(): void {
        this._router.navigate(['./scenario-activities']);
    }
}


/** WEBPACK FOOTER **
 ** ./app/scenario-activities/scenario-reforecast.component.ts
 **/